import React, { FC } from 'react';
import { getHtmlId, getLongTypeDescription, NumberedNodeType, useNumberedNodes } from '../../../tiptap/numbering';
import { capitalizeFirstLetter } from '../../../../../utils/string';
import { StyledLink } from '../../../../../Components';
import { scrollElementIntoViewById } from '../../../scrolling';

export const InternalNodeLink: FC<{ id: string }> = ({ id }) => {
  const numberedNodes = useNumberedNodes();
  const numberedNode = numberedNodes.get(id);
  if (!numberedNode) {
    return null;
  }
  return (
    <div>
      <StyledLink
        to=""
        onClick={(e) => {
          e.preventDefault();
          scrollElementIntoViewById(getHtmlId(numberedNode));
        }}>
        {capitalizeFirstLetter(getLongTypeDescription(numberedNode?.type as NumberedNodeType))} {numberedNode?.numbering}
      </StyledLink>
    </div>
  );
};
